<template>
  <tr
    v-bind:key="result.id">
      <td>{{ result.id }}</td>
      <td>{{ result.propertyId }}</td>
      <td :id="'serviceCat-' + result.id">{{ result.serviceCategory.length > 20 ? result.serviceCategory.slice(0,20) + '...' : result.serviceCategory }}</td>
      <td :id="'serviceComp-' + result.id">{{ result.serviceType.length > 25 ? result.serviceType.slice(0,25) + '...' : result.serviceType }}</td>
      <td>{{ result.serviceAgreementType }}</td>
      <td>{{ result.serviceStatus }}</td>
      <td>{{ result.staffLeadName }}</td>
      <td>
        <router-link
          :to="{ name: 'projectService', params: {
          project_id: result.projectId,
          id: result.id }}"
          class="btn btn-secondary btn-sm">
          View
        </router-link>
      </td>
      <b-tooltip :target="'serviceComp-' + result.id">
        {{ result.serviceType }}
      </b-tooltip>
  </tr>
  <!-- <small :id="'serviceCat-'+ service.id">{{ getCategoryName(service.categoryId).length > 15 ? getCategoryName(service.categoryId).slice(0,15) + '...' : getCategoryName(service.categoryId) }}</small> -->
  
</template>
<script>
export default {
  name: 'ServiceSearchResultRow',
  props: {
    result: {
      type: Object,
    },
  },
};
</script>
